class AnimatedLogo {
  constructor() {
    this.logo = document.querySelector('[data-animated-logo]');
    if (!this.logo) return;
    
    this.header = document.getElementById('SiteHeader');
    this.isHomepage = this.logo.classList.contains('animated-logo--home');
    this.animationEnabled = this.logo.getAttribute('data-animation-enabled') === 'true';
    
    // Get logo colors from data attributes
    this.darkColor = this.logo.getAttribute('data-logo-dark-color') || '#2F2E2E';
    this.lightColor = this.logo.getAttribute('data-logo-light-color') || '#F4F2F1';
    
    console.log('Logo colors from attributes:', {
      dark: this.darkColor,
      light: this.lightColor
    });
    
    // Set header height CSS variables
    this.setHeaderHeightVariables();
    
    // Debug initial state
    console.log('Initial header transparent:', this.header.classList.contains('hdr-trans-hp'));
    console.log('Initial logo classes:', this.logo.className);
    console.log('Logo dimensions:', this.logo.offsetWidth, 'x', this.logo.offsetHeight);
    console.log('Is homepage:', this.isHomepage);
    console.log('Animation enabled:', this.animationEnabled);
    console.log('Header height:', this.header.offsetHeight);
    
    // Set initial state
    if (this.isHomepage && this.animationEnabled) {
      // For homepage with animation enabled, initialize scroll handling
      this.init();
    } else {
      // For non-homepage or animation disabled, always force dark logo
      this.forceDarkLogo();
    }
    
    // Handle window resize to update header height variables
    window.addEventListener('resize', () => {
      this.setHeaderHeightVariables();
    });
  }
  
  setHeaderHeightVariables() {
    if (this.header) {
      const headerHeight = this.header.offsetHeight;
      const headerHeightHalf = headerHeight / 2;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-half', `${headerHeightHalf}px`);
    }
  }

  forceDarkLogo() {
    this.logo.classList.add('logo-dark');
    this.logo.classList.remove('logo-light');
    
    // Apply dark color directly to the logo
    this.applyLogoColor(this.darkColor);
    
    console.log('Forced dark logo with color:', this.darkColor);
  }

  forceLightLogo() {
    this.logo.classList.add('logo-light');
    this.logo.classList.remove('logo-dark');
    
    // Apply light color directly to the logo
    this.applyLogoColor(this.lightColor);
    
    console.log('Forced light logo with color:', this.lightColor);
  }
  
  applyLogoColor(color) {
    // Apply color directly to SVG elements if present
    const svgElements = this.logo.querySelectorAll('svg');
    
    if (svgElements.length > 0) {
      console.log('Applying color to SVG elements:', color);
      
      svgElements.forEach(svg => {
        // Apply color to all SVG paths, rects, circles, and polygons
        const paths = svg.querySelectorAll('path, rect, circle, polygon');
        paths.forEach(path => {
          path.setAttribute('fill', color);
        });
        
        // Also set the SVG fill attribute directly
        svg.setAttribute('fill', color);
      });
    } else {
      // If no SVG, try to apply color via CSS custom property
      console.log('No SVG elements found, applying color via CSS variable:', color);
      this.logo.style.setProperty('--logo-color', color);
      
      // Also try to apply color to any img elements
      const imgElements = this.logo.querySelectorAll('img');
      if (imgElements.length > 0) {
        console.log('Applying filter to img elements for color:', color);
        
        // For light color (white/light), use invert filter
        if (this.isLightColor(color)) {
          imgElements.forEach(img => {
            img.style.filter = 'brightness(0) saturate(100%) invert(1)';
          });
        } else {
          // For dark color, use brightness filter
          imgElements.forEach(img => {
            img.style.filter = 'brightness(0) saturate(100%)';
          });
        }
      }
    }
  }
  
  isLightColor(color) {
    // Simple check if color is light (for filter application)
    // Convert hex to RGB and check brightness
    let r, g, b;
    
    if (color.startsWith('#')) {
      // Handle hex color
      const hex = color.substring(1);
      r = parseInt(hex.substr(0, 2), 16);
      g = parseInt(hex.substr(2, 2), 16);
      b = parseInt(hex.substr(4, 2), 16);
    } else if (color.startsWith('rgb')) {
      // Handle rgb/rgba color
      const rgbValues = color.match(/\d+/g);
      if (rgbValues && rgbValues.length >= 3) {
        r = parseInt(rgbValues[0]);
        g = parseInt(rgbValues[1]);
        b = parseInt(rgbValues[2]);
      } else {
        return false;
      }
    } else {
      return false;
    }
    
    // Calculate perceived brightness using the formula
    // (0.299*R + 0.587*G + 0.114*B)
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // If brightness is greater than 0.5, consider it a light color
    return brightness > 0.5;
  }

  init() {
    // Initial check
    this.handleScroll();
    
    // Add scroll listener for homepage
    window.addEventListener('scroll', () => {
      requestAnimationFrame(this.handleScroll.bind(this));
    });
  }

  handleScroll() {
    const scrolled = window.scrollY > 0;
    
    // Position animation
    this.logo.classList.toggle('is-scrolled', scrolled);
    
    // Update logo color based on scroll position directly
    if (scrolled) {
      this.forceDarkLogo();
    } else {
      this.forceLightLogo();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AnimatedLogo();
});

customElements.define('animated-logo', class extends HTMLElement {
  connectedCallback() {
    // This is just to register the custom element
  }
}); 